import React from "react";
import PropTypes from "prop-types";
import { EcomApplePay } from "@lululemon/mwa-apple-pay";
import styles from "../styles/apple-pay-button.module.scss";

// This is the new apple pay button from mwa libraries
const ApplePayButton = ({
  graphqlClient,
  currencyCode,
  locale,
  isBopis,
  applePayUpgradeLDFlag,
  bopisStore,
  productInfo,
  isMixedOrder,
  shapeConfig,
  handlePartialLogin,
  defaultBagId,
  onClickCapture
}) => {
  return (
    <div className={styles.applePayContainer} onClickCapture={onClickCapture}>
      <EcomApplePay
        graphqlClient={graphqlClient}
        currencyCode={currencyCode}
        locale={locale}
        isBopis={isBopis}
        enableApplePayUpgrade={applePayUpgradeLDFlag}
        bopisStore={bopisStore}
        type="express"
        productInfo={productInfo}
        isMixedOrder={isMixedOrder}
        shapeConfig={shapeConfig}
        handlePartialLogin={handlePartialLogin}
        defaultBagId={defaultBagId}
      />
    </div>
  );
};

ApplePayButton.defaultProps = {
  bopisStore: {},
  skuId: "",
  productId: "",
  currencyCode: "USD"
};

ApplePayButton.propTypes = {
  bopisStore: PropTypes.shape({
    id: PropTypes.string,
    storeName: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  deliveryType: PropTypes.string.isRequired,
  skuId: PropTypes.string,
  productId: PropTypes.string,
  currencyCode: PropTypes.string,
  activeSize: PropTypes.string.isRequired
};

export default ApplePayButton;
